// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3u1jS","messages":"Chat_messages__19x-d","dateDivider":"Chat_dateDivider__1n6tq"};